import { cva } from 'class-variance-authority';
import { cn } from '@workspace/lib/utils';
import { theme } from '../../theme';
import { Icon } from '../Icon';
import { IconMap } from '../IconMap';

const labelVariants = cva('items-center text-md font-semibold', {
  variants: {
    site: {
      porta: '',
      portaNZ: '',
      redRec: 'block pb-1 font-bold',
      easycraft: '',
    },
  },
  defaultVariants: { site: 'porta' },
});

interface LabelProps {
  text: string;
  isRequired?: boolean;
  iconName?: keyof typeof IconMap;
  iconSize?: number;
  className?: string;
}

export const Label = ({ text, isRequired = false, iconName, iconSize = 16, className = '' }: LabelProps) => {
  return (
    <label className={cn(labelVariants({ site: theme }), className)}>
      {isRequired && <span className="text-error-300">*</span>}
      {text}
      {iconName && <Icon name={iconName} size={iconSize} className="text-secondary-300" />}
    </label>
  );
};
